// extracted by mini-css-extract-plugin
export default {"inputStyle":"styles_inputStyle__3pAuV","notice":"styles_notice__ze6DB","uppercase":"styles_uppercase__iiLeV"};